import { render } from "./StartShoppingSection.vue?vue&type=template&id=37e84030&scoped=true"
import script from "./StartShoppingSection.vue?vue&type=script&lang=js"
export * from "./StartShoppingSection.vue?vue&type=script&lang=js"

import "./StartShoppingSection.vue?vue&type=style&index=0&id=37e84030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e84030"]])

export default __exports__